import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/membershipPeriod'
export const namespace = 'membershipPeriod'
export const clientRoute = '/membership/period'
export const dependencies = ['membership']
export const params = {
  include: 'membership'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'registrationDate'
const subtitleColumn = 'dropDate'
const infoColumns = ['expiryDate', 'notes']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
